import {useEffect} from "react";
import styled, {keyframes} from "styled-components";

export interface ToastProps {
	message: string;
	onClose: () => void;
	duration?: number;
	nowrap?: boolean;
}

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, 20px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
`;

const fadeOut = keyframes`
  to {
    opacity: 0;
  }
`;

const ToastWrap = styled.div<{$nowrap?: boolean}>`
	position: absolute;
	bottom: 40px;
	left: 50%;
	transform: translateX(-50%);
	padding: 8px 24px;
	border-radius: 16px;
	background: rgba(42, 42, 42, 0.9);
	color: #fff;
	font-size: var(--basic-size);
	font-family: "PT-semiBold";
	white-space: ${({$nowrap}) => ($nowrap ? "nowrap" : "normal")};
	animation:
		${fadeInUp} 0.25s ease,
		${fadeOut} 0.3s ease 2.7s forwards;
	z-index: 105;
`;

const Toast = ({message, onClose, duration = 3000, nowrap}: ToastProps) => {
	useEffect(() => {
		const timer = setTimeout(onClose, duration);
		return () => clearTimeout(timer);
	}, [duration, onClose]);

	return <ToastWrap $nowrap={nowrap}>{message}</ToastWrap>;
};

export default Toast;
